module.exports = __webpack_public_path__ + "static/img/sdgs_my_bottle_ph.22876bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/sdgs_my_bottle_ph.png
// module id = jClp
// module chunks = 0